<script lang="ts">
import Breadcrumbs from "../../components/breadcrumbs.svelte";
import type { Breadcrumb } from "../../components/breadcrumbs.svelte";
import type { PageData } from "./$types";

export let data: PageData;

const breadcrumbs: Breadcrumb[] = [
	{ label: "トップ", href: "/" },
	{ label: "特定商取引法に基づく表記", href: "/tradelaw/" },
];
</script>

<Breadcrumbs breadcrumbs={breadcrumbs} />
<div class="inner bg-bgGray pt-8">
  <section class="px-6 bg-white rounded-xl mb-4">
    <article class="content">
      <h2 class="mb-10">
        特定商取引法に基づく表記
      </h2>
      {@html data.content}
    </article>
  </section>
</div>